import { ApolloLink, Observable } from "@apollo/client";
import { MISSING_FIELD_ERROR_CODE } from "../graphql/GqlError";
import { extractTopLevelFieldNameData } from "../queryUtils/extractTopLevelFieldNameData";
export function createMissingSchemaLink() {
    return new ApolloLink(function missingSchemaTerminatingLink(operation) {
        const topLevelFieldNameData = extractTopLevelFieldNameData(operation.query);
        // Generate an error for each top-level field
        const errors = topLevelFieldNameData.map(({ name, alias })=>{
            const missingFieldErrorExtensions = {
                actionId: null,
                traceId: null,
                unstable_requestId: null,
                error: {
                    code: MISSING_FIELD_ERROR_CODE,
                    topLevelField: name,
                    // Mimicking backend behavior
                    status: 200
                }
            };
            return {
                message: `Field ${name} was not found in any schema. Please make sure to declare your schemas and their fields correctly in your DataProvider`,
                path: alias ? [
                    alias
                ] : [
                    name
                ],
                extensions: missingFieldErrorExtensions
            };
        });
        // Return the response as an Observable
        return new Observable((observer)=>{
            observer.next({
                data: null,
                errors: errors
            });
            observer.complete();
        });
    });
}

//# sourceMappingURL=createMissingSchemaLink.js.map